const Settings = {
    TITLE: 'RideClub',
    API: 'https://backend.proserver.dev',
    SOCKET: 'https://backend.proserver.dev',
    DEFAULT_LANG: 'PL'
}

export default Settings;